<script>
	import CustomCollapseCard from "src/components/CustomCollapseCard/CustomCollapseCard.svelte";
	import CustomInput from "src/components/CustomInput/CustomInput.svelte";
	import CustomSearch from "src/components/CustomSearch/CustomSearch.svelte";
	import { extractErrorMessage } from "src/utils/misc";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import { debounce } from "lodash";
	import {
		getVehicleDetails,
		loadVehicleOptions,
	} from "src/services/vehicle";

	export let selectedVehicleOption;
	export let form;
	export let vehicleId;
	export let vehicleNumber;
	export let assetsOwner;
	export let carMake;
	export let carModel;

	// load all carplates based on user input

	// when vehicle is selected, fetch other vehicle details
	async function onVehicleSelect(option) {
		$vehicleId.value = option.value;
		vehicleNumber.set(option.label);
		try {
			const res = await getVehicleDetails($vehicleId.value);
			const data = res.data;

			// populate form fields with vehicle details
			assetsOwner.set(data.assetOwnerName || "");
			carMake.set(data.vehicleMakeName || "");
			carModel.set(data.vehicleModelName || "");
		} catch (e) {
			console.error(e);
			extractErrorMessage(e);
			assetsOwner.set("");
			carMake.set("");
			carModel.set("");
		}
	}

	const vehicleOptions = debounce(loadVehicleOptions, 300, {
		leading: true,
		trailing: true,
	});

	$: if (selectedVehicleOption) {
		onVehicleSelect(selectedVehicleOption);
	}
</script>

<CustomCollapseCard
	title="Vehicle Information"
	isOpenDefault={true}
	customClass="mb-4"
>
	<Col xs={6}>
		<Row class="mb-4">
			<Col>
				<Row>
					<Col>
						<label for="vehicleNumber" class="d-block">
							<span>
								Vehicle No<span class="text-danger">*</span>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col>
						<CustomSearch
							bind:value={selectedVehicleOption}
							loadOptions={vehicleOptions}
							placeholder="Enter vehicle no"
							error={$form.hasError("vehicleNumber.required")}
							errorText="Vehicle no is required"
							handleClear={() => {
								selectedVehicleOption = null;
								vehicleId = null;
								$vehicleNumber.value = "";
								$assetsOwner.value = "";
								$carMake.value = "";
								$carModel.value = "";
							}}
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="assetOwner" class="d-block">
							<span>
								Asset Owner<span class="text-danger">*</span>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col>
						<CustomInput
							type="text"
							disabled={true}
							placeholder="Enter Asset Owner"
							bind:value={$assetsOwner.value}
							error={$form.hasError("assetsOwner.required")}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
		<Row>
			<Col>
				<Row>
					<Col>
						<label for="carMake" class="d-block">
							<span>
								Make<span class="text-danger">*</span>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col>
						<CustomInput
							type="text"
							disabled={true}
							placeholder="Enter Make"
							bind:value={$carMake.value}
							error={$form.hasError("carMake.required")}
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="carModel" class="d-block">
							<span>
								Model<span class="text-danger">*</span>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col>
						<CustomInput
							type="text"
							disabled={true}
							placeholder="Enter model"
							bind:value={$carModel.value}
							error={$form.hasError("carModel.required")}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
	</Col>
</CustomCollapseCard>
